import { formatDistance, isValid, parseISO } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { isString } from 'lodash';

export function formatDate(
    input: string | number | Date,
    {
        short = false,
        pattern: initialPattern,
        withTime = false,
        distance = false,
        timeZone = 'America/New_York',
    }: {
        short?: boolean;
        pattern?: string;
        withTime?: boolean;
        distance?: boolean;
        timeZone?: string;
    } = {},
) {
    let pattern = withTime ? 'MMM dd, yyyy HH:mm:ss' : 'MMM dd, yyyy';
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!input) {
        return '-';
    }

    if (short) {
        pattern = pattern.replace(', yyyy', '');
    }

    if (distance) {
        return formatDistance(
            new Date(isString(input) && isSafari && isValid(parseISO(input)) ? parseISO(input) : input),
            new Date(),
            {
                addSuffix: true,
            },
        );
    }

    return format(utcToZonedTime(new Date(input), timeZone), initialPattern || pattern, { timeZone });
}
